import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from './apis';
import Swal from 'sweetalert2';
import { RootState } from '../../domain/models/RootState';

export const getAllReturns = createAsyncThunk<any, any, { state: RootState }>(
  'returns/getAllReturns',
  async ({ filter, pagination }: any, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const filterTmp =
        auth.type === 3 ? `&users_id=${auth.id}${filter}` : filter;
      return await API.getAllReturns(auth.token, filterTmp, pagination);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);
